module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hungry Girl Staples")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("You’ll find these specific products popping up in many of our recipes:")]), _vm._v(" "), _c('div', {
    staticClass: "unOrderedList"
  }, [_c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Fiber One bran cereal (original)")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Splenda No Calorie Sweetener (granulated)")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Boca Original Meatless Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Bisquick Heart Smart baking mix")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Pillsbury Reduced Fat Crescent Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Laughing Cow Light Original Swiss cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("La Tortilla Factory Smart & Delicious Low Carb/High Fiber Tortillas")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("House Foods Tofu Shirataki, Fettuccine, and Spaghetti Shaped Noodle Substitute")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Cool Whip Free")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/21a.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "unOrderedList"
  }, [_c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Fat Free Reddi-wip")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("I Can’t Believe It’s Not Butter! Spray")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Coffee-mate Sugar Free French Vanilla powdered creamer")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hellmann’s/Best Foods Dijonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Frank’s RedHot Original Cayenne Pepper Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "-4%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/star.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jell-O Sugar Free Pudding Snacks, assorted flavors")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/21b.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8c460e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312556174_fm03.vue
// module id = 81
// module chunks = 0